import { render, staticRenderFns } from "./moduleFour.vue?vue&type=template&id=6b8674be"
import script from "./moduleFour.vue?vue&type=script&lang=js"
export * from "./moduleFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports